"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function default_1(func, wait) {
    var _this = this,
        _arguments = arguments;

    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var timeout = void 0;
    return function (reason, ocaml) {
        var context = _this;
        var args = _arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) {
                func.apply(context, [reason, ocaml]);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.default = default_1;


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/home/travis/build/codekiln/gradus-reason/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/utils/debounce.tsx